import { Container } from "./Container";
import { Navigation } from "./Navigation";

const HeaderContent = Object.assign(Container, { Navigation });

export { HeaderContent };
